// import hooks
import { useTranslation } from "react-i18next";
import { useState } from "react";

// import components
import Modal from "react-bootstrap/Modal";
import OtpInput from "react-otp-input";

// import assets
import "../../assets/css/modals.css";
import { oceanLogo } from "../../utils/images";
import { whiteCart } from "../../utils/cards-svgs";

const VerifyModal = (props) => {
    const [t] = useTranslation("global");
    const [otp, setOtp] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className={`login-modal custom-modal ${props.lang} ${props.view} ${props.mode.mode}`}
        >
            <Modal.Body>
                <div className="modal-cls-container">
                    <div
                        className="closeSvg"
                        onClick={() => props.mode.cls(false)}
                    ></div>
                </div>
                <div className="custom-modal-head">
                    <img
                        src={oceanLogo}
                        alt="logo"
                        className="custom-modal-img"
                    />
                    <h2 className="custom-modal-h">{t("modals.otp.head")}</h2>
                    <p className="custom-modal-p">{t("modals.otp.txt")}</p>
                </div>
                <div className="custom-modal-body">
                    <form
                        className="custom-modal-form login-form"
                        onSubmit={(e) => handleSubmit(e)}
                    >
                        <div className="label-input-div otp-input-div">
                            {/* <label className="custom-modal-label">
                                {t("modals.otp.otp")}
                            </label>  */}
                            {/* <input type="text" className="custom-modal-input" /> */}
                            <OtpInput
                                onChange={(val) => setOtp(val)}
                                value={otp}
                                inputStyle="inputStyle"
                                numInputs={4}
                                renderSeparator={" "}
                                renderInput={(props) => <input {...props} />}
                            />
                        </div>
                        <p className="custom-modal-error login-error">
                            {t("modals.otp.error")}
                        </p>

                        <button type="submit" className="custom-modal-btn">
                            <img src={whiteCart} alt="icon" />
                            <span>{t("modals.otp.btn")}</span>
                        </button>
                    </form>
                </div>
                <div className="custom-modal-footer">
                    <p>
                        <span>{t("modals.otp.txt2")}</span>{" "}
                        <a href="#" className="custom-modal-link">
                            {t("modals.otp.link")}
                        </a>
                    </p>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default VerifyModal;
